<template>
  <layout-content>
    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import TableComponent from '@call-tracking/components/tracking-stats-detailed-table';
  import FilterComponent from '@call-tracking/components/tracking-stats-detailed-table-filter';

  export default {
    components: {
      TableComponent,
      FilterComponent
    }
  };
</script>
